/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import BarChartIcon from '@material-ui/icons/BarChart';
import HomeIcon from '@material-ui/icons/HomeOutlined';

export const gateManagerNavigation = [
  {
    title: 'Pages',
    pages: [
      {
        title: 'Overview',
        href: '/overview',
        icon: HomeIcon
      },
      {
        title: 'Management',
        href: '/management',
        icon: BarChartIcon,
        children: [
          {
            title: 'Bookings',
            href: '/management/bookings'
          },
        ]
      },
    ]
  }
]

export const partnerNavigation = [
  {
    title: 'Pages',
    pages: [
      {
        title: 'Overview',
        href: '/overview',
        icon: HomeIcon
      },
      {
        title: 'Management',
        href: '/management',
        icon: BarChartIcon,
        children: [
          {
            title: 'Bookings',
            href: '/management/bookings'
          },
          {
            title: 'Parkings',
            href: '/management/parkings'
          },
          {
            title: 'Withdrawals',
            href: '/management/withdrawals'
          },
        ]
      },
    ]
  }
]

export const adminNavigation = [
  {
    title: 'Pages',
    pages: [
      {
        title: 'Overview',
        href: '/overview',
        icon: HomeIcon
      },
      {
        title: 'Management',
        href: '/management',
        icon: BarChartIcon,
        children: [
          {
            title: 'Users',
            href: '/management/users'
          },
          {
            title: 'Bookings',
            href: '/management/bookings'
          },
          {
            title: 'Parkings',
            href: '/management/parkings'
          },
          {
            title: 'Withdrawals',
            href: '/management/withdrawals'
          },
        ]
      },
    ]
  }
];

export const agenceNavigation = [
  {
    title: 'Pages',
    pages: [
      {
        title: 'Overview',
        href: '/overview',
        icon: HomeIcon
      },
      {
        title: 'Management',
        href: '/management',
        icon: BarChartIcon,
        children: [
          {
            title: 'Withdrawals',
            href: '/management/withdrawals'
          },
          {
            title: 'Referred Users',
            href: '/management/referred'
          },
        ]
      },
    ]
  }
];